export const goBackOrHome = (history): void => {
  if (history.length !== 1 && window.location.hostname === document.referrer.split('/')[2]) {
    history.goBack()
  } else {
    window.location.href = '/'
  }
}
